
<div class="hsubscription-list-page">
<div class="list-header">
        <h2 class="text-center">Liste des souscriptions</h2>
    </div>   
    <div class="mb-3">
        <button class="btn btn-primary" type="button"  (click)="goToCreate()">Ajouter une souscription</button>
    </div>
    @if (subscriptions.length == 0) {
        <div class="empty-state">
            <p>Aucune souscription trouvée. Utilisez le formulaire pour ajouter une nouvelle souscription.</p>
        </div>
    }

    @if (subscriptions.length > 0) {
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead class="table-success">
                    <tr>
                        <th>Client</th>
                        <th>Produit</th>
                        <th>Montant périodique</th>
                        <th>Fréquence</th>
                        <th>Statut</th>
                        <th>Date de début</th>
                        <th>Durée</th>
                    </tr>
                </thead>
                <tbody>
                   @for( subscription of subscriptions| paginate:pageConfig; track subscription.id) {
                        <tr>
                            <td>
                                <div class="customer-info">
                                    <strong>{{ subscription.customer?.firstName }} {{ subscription.customer?.lastName }}</strong>
                                    <br>
                                    <small class="text-muted">{{ subscription.customer?.phone }}</small>
                                    <br>
                                    <small class="text-muted">{{ subscription.customer?.email }}</small>
                                </div>
                            </td>
                            <td>
                                <div class="product-info">
                                    <strong>{{ subscription.product?.name }}</strong>
                                    <br>
                                    <small class="text-muted">{{ subscription.product?.type }} - {{ subscription.product?.zone }}</small>
                                </div>
                            </td>
                            <td><strong>{{ subscription.periodicAmount }} CFA</strong></td>
                            <td>{{ subscription.paymentFrequency }}</td>
                            <td>
                                <span class="{{ getStatusClass(subscription.status) }}">{{subscription.status}}</span>
                            </td>
                             <td>{{ formatDate(subscription.startDate) }}</td>
                            <td>{{ subscription.product?.durationYears }} an(s)</td>
                        </tr>
                   }
                </tbody>
            </table>
            <div class="d-flex justify-content-center">
    <pagination-controls previousLabel="Precedent" nextLabel="Suivant" (pageChange)="onNextPage($event)">
    </pagination-controls>
  </div>
        </div>
    }
</div>